import type { CSSProperties } from "react";

interface PlayfulHeaderProps {
    text: string;
    size?: "small" | "default";
}

function PlayfulHeader(props: PlayfulHeaderProps) {
    const headerStyle: CSSProperties = {
        height: "220px",
    }
    const headingStyle: CSSProperties = {
        fontSize: "2.5rem",
        fontWeight: "bold",
        color: "#eafff1",
    }
    if (props.size === "small") {
        headerStyle.height = "110px"
        headingStyle.fontSize = "1.5rem"
    }

    const textToChars = (text: string): string[] => {
        const chars: string[] = [];
        for (let i = 0; i < text.length; i++) {
            if (text[i] !== ' ') {
                chars.push(text[i]);
            } else {
                chars.push(" ")
            }
        }
        return chars
    }

    const characterToSpan = (char: string, index: number) => {
        return (
            <span key={"playfulchar-char-" + index} style={{ animationDelay: `${(index % 10) * 0.2}s` }}>
                {char}
            </span>
        );
    }

    return (
        <div className="playful-header" style={headerStyle}>
            <h1 style={headingStyle} className="wavy-text">
                {props.text.split("\n").map((line: string, lineIndex: number) => (
                  <div key={"playfulchar-line-" + lineIndex + line}>
                      {textToChars(line).map(characterToSpan)}
                  </div>
                ))}
            </h1>
            <div className="color-blobs layer-1"></div>
            <div className="color-blobs layer-2"></div>
        </div>
    );
}

export default PlayfulHeader
